import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const proofOfAccidentPrevention: TaskDefinition = {
  taskName: onboardingTasks.NeedProofThatAccidentPreventionCourseTaken,
  config: {
    staffDisplayName: 'Proof of accident prevention certification',
    appcuesModalId: 'b3047d65-9347-4a65-bd77-70deb638bb1b',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of Accident Prevention Course',
    account: {
      toastMessage: 'Your proof of accident prevention documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed, data }) => {
        const customerSuffix = data.customer ? ` for ${data.customer}` : '';
        return {
          title: `Proof of accident prevention course${customerSuffix}`,
          incompleteSubtitle: 'Provide proof that the accident prevention course was completed to keep your discount.',
          completedSubtitle: `You have successfully submitted for review the accident prevention documents for ${affectedPolicies}.`,
          actionLabel: 'Upload proof',
          modalTitle: `Upload your proof of accident prevention course${customerSuffix}`,
          contentSections: [
            {
              title: 'What documents are accepted?',
              body: 'Certificate of completion from an approved accident prevention or defensive driving course'
            },
            {
              title: 'When do I need to submit these documents?',
              body: `You have ${daysAllowed} days from your policy effective date to turn in verification listed above before the discount is removed.`
            }
          ]
        };
      }
    }
  }
};
